<template>
  <div class="agreement">
    <p class="title">极兔开放平台用户注册使用协议</p>
    <p>【提示条款】</p>
    <p class="indent">您在签署或在线点击同意本协议或使用极兔开放平台之前，<span class="test-underline" >请务必审慎阅读、充分理解本协议各条款内容，特别是免除或者限制责任、法律适用和争议解决等以粗体下划线格式特别标识的条款，您应重点阅读。</span></p>
    <p class="indent">若您签署或在线点击同意本协议或使用极兔开放平台，即表示您已充分阅读、理解并接受本协议的全部内容，并与极兔速递有限公司及其子公司、分支机构、关联公司（以下简称“<span class="text-bold">极兔</span>”）达成一致。<span class="test-underline">本协议自您签署或点击同意本协议之时或使用极兔开放平台的行为发生之时（以时间在先者为准）起生效。如您对本协议有任何疑问，或者不同意本协议或其中任何条款约定，请勿签署或点击同意本协议并立即停止使用极兔开放平台。</span></p>

    <p class="title-sub">1. 签约主体、协议内容及变更</p>
    <p>1.1. “极兔开放平台”是由【极兔速递有限公司】拥有及营运的网站，仅提供相关的在线自助申请、测试和快递业务接口服务，除此之外与服务有关的上网所需设备（包括个人电脑、手机、其它与接入互联网或移动网有关的上网装置）及所需的费用（与此服务相关的电话费、上网费、为使用移动网而支付的手机费等）均应由用户自行承担。</p>
    <p>1.2. 本协议由您与极兔共同签署，对您和极兔均具有合同效力。本协议内容包括协议正文、附件及所有极兔已经发布的或将来可能发布的平台规则。<span class="test-underline">所有附件及平台规则均为本协议不可分割的一部分，与协议正文具有同等法律效力。协议正文、附件与平台规则相冲突的，以发布在后的文件为准执行。</span></p>
    <p>1.3. 极兔有权根据需要不时地变更（包括但不限于制定、修订、废止）本协议正文、附件及/或平台规则，并按本协议约定方式通知您，<span class="test-underline">如您不同意变更事项，应当立即停止使用极兔开放平台，如您继续使用极兔开放平台，则视为您同意前述变更事项，变更事项自极兔通知您之时起生效。</span></p>

    <p class="title-sub">2. 用户注册与使用</p>
    <p>2.1. 用户进行注册时，必须填写准确、真实、有效的资料，如果提供的资料包含有不正确的信息，本网站保留结束用户使用网络服务资格的权利。倘若用户提供任何不真实、不准确、不完整或不能反映当前情况的资料，或极兔有合理理由怀疑该等资料不真实、不准确、不完整或不能反映当前情况，极兔有权暂停或终止您的注册身份及资料，并拒绝您在目前或将来对“服务”(或其任何部份) 以任何形式使用。</p>
    <p>2.2. 用户按照注册页面提示填写信息、设置密码、阅读并同意本协议并完成全部注册程序后或以其他极兔开放平台允许的方式实际使用极兔开放平台服务时，用户即成为极兔开放平台用户，极兔开放平台根据会员的用户名和密码确认用户身份。用户对该账号和密码的安全负全部责任，且应当对以其用户账号进行的所有活动和事件负法律责任。用户若发现任何非法盗用极兔开开放平台用户账号、密码或存在安全漏洞的情况，请立即通告极兔。用户理解极兔开放平台对用户的请求采取行动需要合理时间，极兔对在采取行动前已经产生的后果（包括但不限于您的任何损失）不承担任何责任。</p>
    <p>2.3. 用户注册成功，并已设置相应密码后，可以随时登陆网站账户信息页面更改其基本信息。用户登记信息如有变更的，应及时在极兔开放平台补充提交变更后的资料，否则，用户应自行承担由此遭受的损失。</p>
    <p>2.4. 您的账户（包括账户名、密码等，下同）由您自行设置并由您保管，极兔在任何时候均不会主动要求您提供账户，请您务必妥善保管账户。<span class="test-underline">因您主动泄露、保管不当而泄露或遭受他人攻击、诈骗等行为导致的损失及后果，极兔不承担任何责任。</span></p>

    <p class="title-sub">3. 极兔开放平台服务及规范</p>
    <p>3.1. 用户登录后可以通过调用极兔的各类服务接口，但是调用过程中所需的技术与设备全部由用户自行负责，极兔并不对此负责。</p>
    <p>3.2. 用户通过调用接口能在极兔的规则范围内进行快件寄递、信息跟踪，但是查询的时限以极兔通过各种方式公布的为准。</p>
    <p>3.3. 争议处理</p>
    <p>3.3.1. <span class="test-underline">您在使用极兔开放平台过程中与其他用户发生争议的，您与争议相对方应自行通过协商、调解、仲裁、诉讼等途径依法解决，或者申请极兔介入调处。</span></p>
    <p>3.3.2. <span class="test-underline">您或争议相对方任一方申请极兔介入调处的，则极兔将作为独立的第三方，根据其所调查了解到的争议事实并依据平台规则作出调处决定。</span></p>
    <p>3.3.3. 如您或争议相对方任一方对极兔的调处决定不满意，仍有权采取其他争议处理途径解决争议，但<span class="test-underline">通过其他争议处理途径未取得终局决定之前，您与争议相对方仍应先行履行调处决定。</span></p>
    <p>3.4. 责任限制</p>
    <p>3.4.1. 您理解并同意，在争议调处中，极兔并非专业人士，仅能以普通人的认知水平对您或争议相对方提交的材料进行鉴别、对争议事实等做出判断。因此，<span class="test-underline">除恶意所致外，极兔对争议调处决定免责，如您因此遭受损失，您同意自行向受益人或致损方索赔。</span></p>
    <p>3.4.2.<span class="test-underline">极兔按照法律规定保障平台的正常运作，但不对由于信息网络设备维护、连接故障，电脑、通讯或其他系统的故障，电力故障，罢工，暴乱，起义，骚乱，生产力或生产资料不足，火灾，洪水，风暴，爆炸，不可抗力，战争，政府行为，司法行政机关的命令或因第三方原因而给您造成的损害结果承担责任。</span></p>
    <p>3.4.3. 您使用第三方提供的与极兔开放平台相关的任何服务时，请您自行与第三方就相关权利义务进行明确约定。<span class="test-underline">极兔不对您与第三方之间的纠纷承担任何责任。</span></p>

    <p class="title-sub">4. 用户信息保护、授权及使用</p>
    <p>4.1. 个人信息的保护</p>
    <p>极兔非常重视用户个人信息的保护，在您使用极兔开放平台时，<span class="test-underline">您同意极兔按照相关法律法规之规定、本协议约定以及公布在极兔相关产品或极兔开放平台的隐私政策收集、存储、使用、披露和保护您的个人信息。</span></p>
    <p>4.2. 非个人信息的保证与授权</p>
    <p>4.2.1. 您声明并保证，<span class="test-underline">您对您所发布和提供的信息（包括但不限于您在极兔开放平台任何位置发布的信息）拥有合法、充分的权利，否则，极兔有权对您发布或提供的信息依法或依本协议进行删除或屏蔽。</span></p>
    <p>4.2.2. 您应当确保您所发布的信息不存在下列情形：</p>
    <p>（一） 违反国家法律法规禁止性规定的。</p>
    <p>（二） 政治宣传、封建迷信、淫秽、色情、赌博、暴力、恐吓或者教唆犯罪的。</p>
    <p>（三） 欺诈、虚假、不准确或存在误导性的。</p>
    <p>（四） 侵犯他人知识产权或涉及第三方商业秘密及其他专有权利的。</p>
    <p>（五） 侮辱、诽谤、恐吓、涉及他人隐私等侵害他人合法权益的。</p>
    <p>（六） 存在可能破坏、篡改、删除、影响极兔开放平台正常运行或未经授权秘密获取极兔开放平台及其他用户的数据、个人资料的病毒、木马、爬虫等恶意软件、程序代码的。</p>
    <p>（七） 其他违背社会公共利益、公序良俗，或依据平台规则之规定不适合发布的。</p>
    <p>4.2.3. <span class="test-underline">为方便您使用极兔提供的其他相关服务，您授权极兔将您在注册、激活账户或其他使用极兔开放平台过程中提供、形成的信息传递给其他相关服务提供者，或从其他相关服务提供者处获取您在注册、使用相关服务期间提供、形成的信息。</span></p>
    <p>4.3. 信息使用</p>
    <p>您使用极兔开放平台时了解、获得的第三方信息，除了用于您自身的所需外，您不得复制、储存、编辑、公布、出租、出售或以其他方式披露、使用等。</p>
    <p>4.4. 征信信息</p>
    <p>您同意无条件并不可撤销地授权极兔及其相关合作方查询并核验您的信息，包括但不限于征信信息、身份信息、联系信息等，并同意极兔与相关合作方共享上述信息。</p>

    <p class="title-sub">5. 用户的违约及处理</p>
    <p>5.1. 违约认定</p>
    <p>5.1.1. 发生如下情形之一的，视为您违约：</p>
    <p>（一） 使用极兔开放平台时违反相关法律法规规定的。</p>
    <p>（二） 违反本协议及平台规则约定的。</p>
    <p>5.2. <span class="test-underline">极兔有权根据您违约行为的风险程度及极兔采取的违约处理措施，通知极兔的相关合作方对您的账户采取资金扣划、止付、解除止付等措施。</span></p>
    <p>5.3. 赔偿责任</p>
    <p>5.3.1. 如您的行为致使极兔遭受损失，您应当赔偿极兔的全部损失。</p>
    <p>5.3.2. 如您的行为致使极兔遭受第三方主张权利，极兔有权在对第三方承担金钱给付等义务后就全部损失向您索赔。</p>
    <p>5.4. 特别约定</p>
    <p>5.4.1. 廉洁是极兔信守的商业交易的基本准则，用户郑重承诺不会作出任何有违廉洁承诺的行为，否则，如发现用户向极兔的员工或其近亲属给付任何不当利益的，用户除依照法律规定的责任外，还应当：</p>
    <p><span class="test-underline">5.4.1.1 向极兔返还因此获得的所有收益；</span></p>
    <p><span class="test-underline">5.4.1.2 承担极兔所有损失，包括但不限于成本增加、商誉损失及监管机关罚款等；</span></p>
    <p><span class="test-underline">5.4.1.3 支付违约赔偿金：违约赔偿金为不当利益总金额的5倍且不低于人民币【5】万元/次，极兔有权依照用户违约、违规情节与程度调整具体违约赔偿金额的金额。</span></p>
    <p>5.4.2.<span class="test-underline">如因您违反了与极兔签署的其他协议导致极兔终止该等协议的，极兔有权中止甚至终止本协议，并以本协议约定的方式通知您。如因您违约导致极兔终止本协议的，极兔有权对您在其他协议项下的合作采取中止甚至终止协议的措施，并以本协议约定的方式通知您。</span></p>

    <p class="title-sub">6. 协议的终止</p>
    <p>6.1. 终止的情形</p>
    <p>6.1.1. 通知解除：协议任何一方均可以提前十五（15）日书面通知的方式解除本协议。</p>
    <p>6.1.2.<span class="test-underline">极兔单方解除权：如您违反本协议中的任何约定、承诺、保证或任何平台规则，极兔都有权立刻解除本协议，并按照本协议约定或平台规则规定对您进行违约处理。</span> </p>
    <p>6.1.3.<span class="test-underline">如您连续满【九十（90）天】未登录极兔开放平台的，极兔有权解除本协议。</span></p>
    <p>6.1.4. 本协议约定的其他终止条件发生或实现，导致本协议终止。</p>
    <p>6.2. 终止后事项</p>
    <p>6.2.1.<span class="test-underline">自本协议终止之日起，极兔将关闭您在极兔开放平台的账户权限，停止提供服务，您将无法登录极兔开放平台。</span></p>
    <p>6.2.2.<span class="test-underline">本协议终止后，极兔有权保留您的注册信息等数据，但极兔没有保存这些数据的义务，亦不承担向您或任何第三方提供任何数据信息的义务，也不就协议终止向您或任何第三方承担责任，但法律另有规定的除外。</span></p>
    <p>6.2.3.<span class="test-underline"> 本协议终止后，协议有效期内已经执行的部分仍应按照实际履行情况及本协议约定进行，对于您过往的违约行为，极兔仍可依据本协议向您追究违约责任。</span></p>

    <p class="title-sub">7. 法律适用与管辖</p>
    <p>7.1. 本协议的订立、履行、解释、变更及争议解决均适用<span class="test-underline">中华人民共和国法律（为避免歧义，不包含冲突法规则及港、澳、台地区法律）。</span></p>
    <p>7.2. 对于因本协议产生的或者与本协议有关的争议，应友好协商解决，协商不成的，协议任一方均可向<span class="test-underline">极兔速递有限公司注册所在地人民法院</span>提起诉讼。</p>

    <p class="title-sub">8. 其他</p>
    <p>8.1.<span class="test-underline"> 如果根据适用的法律认定本协议中的任何条款或者任何条款中的任何部分无效、违法或者不具有可执行性，这种无效、违法或者不具有可执行不影响本协议中的任何其他条款或者这些条款中的任何其他部分的效力。</span></p>
  </div>
</template>

<script>
export default {
  name: 'ArticlesOfAgreement',
  data() {
    return {

    }
  },
  components: {

  }
}
</script>

<style lang="scss" rel="text/css" scoped>
  .agreement{
    background-color: #ffffff;
    font-size: 1em;
    font-weight: 400;
    padding: 20px 30px;
    line-height: 2em;
    .title{
      text-align: center;
      font-size: 2em;
      font-weight: bold;
      margin-bottom: 1em;
    }
    .title-sub{
      font-weight:bold;
      font-size: 1.5em;
    }
    .text-bold {
      font-weight: bold;
    }
    .indent{
      text-indent: 2em;
    }
    .test-underline{
      font-weight:bold;
      text-decoration: underline;
    }
  }
  
</style>
